export default __webpack_public_path__ + "static/media/36I-102746_-15833_0.a076919f.jpg";